/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_608_OptionsInputs */

const en_subtitle_export_608_options = /** @type {(inputs: Subtitle_Export_608_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`608 Options`)
};

const fr_subtitle_export_608_options = /** @type {(inputs: Subtitle_Export_608_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`608 options`)
};

const de_subtitle_export_608_options = /** @type {(inputs: Subtitle_Export_608_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`608 Optionen`)
};

const it_subtitle_export_608_options = /** @type {(inputs: Subtitle_Export_608_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`608 Opzioni`)
};

const ru_subtitle_export_608_options = /** @type {(inputs: Subtitle_Export_608_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`608 Вариантов`)
};

const es_subtitle_export_608_options = /** @type {(inputs: Subtitle_Export_608_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`608 Opciones`)
};

const zh_cn2_subtitle_export_608_options = /** @type {(inputs: Subtitle_Export_608_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`608 选项`)
};

const ja_subtitle_export_608_options = /** @type {(inputs: Subtitle_Export_608_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`608オプション`)
};

const hi_subtitle_export_608_options = /** @type {(inputs: Subtitle_Export_608_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`608 विकल्प`)
};

const pt_pt2_subtitle_export_608_options = /** @type {(inputs: Subtitle_Export_608_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`608 Opções`)
};

/**
* | output |
* | --- |
* | "608 Options" |
*
* @param {Subtitle_Export_608_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_608_options = /** @type {((inputs?: Subtitle_Export_608_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_608_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_608_options(inputs)
	if (locale === "de") return de_subtitle_export_608_options(inputs)
	if (locale === "it") return it_subtitle_export_608_options(inputs)
	if (locale === "ru") return ru_subtitle_export_608_options(inputs)
	if (locale === "es") return es_subtitle_export_608_options(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_608_options(inputs)
	if (locale === "ja") return ja_subtitle_export_608_options(inputs)
	if (locale === "hi") return hi_subtitle_export_608_options(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_608_options(inputs)
	return en_subtitle_export_608_options(inputs)
});